import { render } from "./Step_one.vue?vue&type=template&id=215b1bd8"
import script from "./Step_one.vue?vue&type=script&lang=js"
export * from "./Step_one.vue?vue&type=script&lang=js"

import "./Step_one.vue?vue&type=style&index=0&id=215b1bd8&lang=less"
script.render = render

export default script